import { LOCATION_ROUTES } from "../../../common/constants";
import {
    ANALYZE_LICENSE_TIERS,
    ANALYZE_LICENSES,
    ANALYZE_TABS,
    ANALYZE_TAB_LICENSES,
} from "../constants";
import { AnalyzeLicense, AnalyzeLicenseTier, AnalyzeTab } from "../types";

export const isAnalyzeTab = (value: string): value is AnalyzeTab =>
    Object.values(ANALYZE_TABS).includes(value as AnalyzeTab);

export const getAnalyzeTabQuery = (pathname: string, tabId: AnalyzeTab) =>
    pathname === LOCATION_ROUTES.ANALYZE_TAB ? { tabId } : {};

export const getLockedTabLicense = (
    tabId: AnalyzeTab,
    licenses: { isPremium: boolean; isEnterprise: boolean }
) => {
    const hasLicense: Record<AnalyzeLicense, boolean> = {
        [ANALYZE_LICENSES.PREMIUM]: licenses.isPremium,
        [ANALYZE_LICENSES.ENTERPRISE]: licenses.isEnterprise,
    };
    const license = ANALYZE_TAB_LICENSES[tabId];

    return license && !hasLicense[license] ? license : undefined;
};

export const getAnalyzeLicenseTier = (licenses: {
    isLicensed: boolean;
    isPremium: boolean;
    isEnterprise: boolean;
}): AnalyzeLicenseTier => {
    if (licenses.isEnterprise) return ANALYZE_LICENSE_TIERS.ENTERPRISE;
    if (licenses.isPremium) return ANALYZE_LICENSE_TIERS.PREMIUM;
    if (licenses.isLicensed) return ANALYZE_LICENSE_TIERS.BASIC;

    return ANALYZE_LICENSE_TIERS.NONE;
};
